// wallboard store filter key => api-core user_settings key
export const DEFAULT_FILTER_KEYS = {
  campaignIds: 'campaign_ids',
  ringGroupIds: 'ring_group_ids',
  teamIds: 'team_ids'
}

// single-id keys saved before filters took several values
const LEGACY_KEYS = {
  campaignIds: 'campaign_id',
  ringGroupIds: 'ring_group_id',
  teamIds: 'team_id'
}

export function hasAnyFilter (filters) {
  return Object.keys(DEFAULT_FILTER_KEYS).some(key => (filters[key] || []).length > 0)
}

export function toApiFilters (filters) {
  const params = {}

  for (const [storeKey, apiKey] of Object.entries(DEFAULT_FILTER_KEYS)) {
    params[apiKey] = [...(filters[storeKey] || [])]
  }

  return params
}

function savedIds (defaults, storeKey) {
  const ids = defaults?.[DEFAULT_FILTER_KEYS[storeKey]]
  if (Array.isArray(ids)) {
    return ids
  }

  const legacyId = defaults?.[LEGACY_KEYS[storeKey]]
  return legacyId ? [legacyId] : []
}

/**
 * Saved defaults as wallboard store filters. An id missing from its loaded list
 * (line, inbox or team deleted or hidden since saving) is dropped; an empty list
 * counts as not loaded yet, so its ids are kept.
 */
export function toStoreFilters (defaults, { campaigns = [], ringGroups = [], teams = [] } = {}) {
  const lists = { campaignIds: campaigns, ringGroupIds: ringGroups, teamIds: teams }
  const filters = {}

  for (const storeKey of Object.keys(DEFAULT_FILTER_KEYS)) {
    const list = lists[storeKey] || []

    filters[storeKey] = savedIds(defaults, storeKey)
      .filter(id => list.length === 0 || list.some(item => item.id === id))
  }

  return filters
}

const sameIds = (a, b) => a.length === b.length && a.every(id => b.includes(id))

export function matchesDefaults (filters, defaults) {
  if (!defaults) {
    return false
  }

  return Object.keys(DEFAULT_FILTER_KEYS)
    .every(storeKey => sameIds(filters[storeKey] || [], savedIds(defaults, storeKey)))
}
